<template>
  <div>
    <the-welfare />
    <the-entry :data="entry" gray />
  </div>
</template>

<script>
import TheWelfare from '@/components/TheWelfare'
import TheEntry from '@/components/TheEntry'

export default {
  components: { TheWelfare, TheEntry },
  data() {
    return { entry: ['society', 'campus', 'develop', 'life'] }
  },
}
</script>
